import { render, staticRenderFns } from "./arrival.vue?vue&type=template&id=8527ee2a&scoped=true"
import script from "./arrival.vue?vue&type=script&lang=js"
export * from "./arrival.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8527ee2a",
  null
  
)

export default component.exports